import React from "react"
import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { Severity } from "types/general.types"
import ProLimitBannerContent from "components/atoms/Banner/ProLimitBannerContent"

type BannerProps = {
  severity: Severity;
  message: string | React.ReactNode;
  isProLimit?: boolean;
  feature?: string;
  style?: React.CSSProperties;
}

export default function Banner(props: BannerProps) {
  const { message, severity, feature, isProLimit = false, style = {} } = props

  return (
    <Container className="farsi-digits" severity={severity} style={style}>
      {isProLimit ? <ProLimitBannerContent message={message} feature={feature}/> : message}
    </Container>
  )
}

type ContainerProps = {
  theme?: Theme;
  severity: Severity;
}

const Container = styled(Stack)(({ theme, severity }: ContainerProps) => ({
  backgroundColor: theme?.palette[severity]["1"],
  borderRadius: "8px",
  padding: "8px",
  fontSize: "1.1rem",
  color: theme?.palette.gray["16"],
  textAlign: "center"
}))
